import React from 'react';

const Pagination = (props) => {

  const { max_num_pages, filterValues, handlePage } = props;

  let showDotsPrev = false;
  let showDotsNext = false;

  return (
    <div className="pagination _default">

      {filterValues.page > 1 && (
        <a href="#" className='pagination__prev' onClick={e => {
          handlePage(e, 'prev');
        }}></a>
      )}

      {Array.from({ length: max_num_pages }, (_, index) => {
        let i = index + 1,
          template;
        if (i == 1) {
          template = <a key={i} href="#" onClick={e => {
            handlePage(e, 'page', i);
          }} className={`pagination__page ${filterValues.page == i ? '_active' : ''}`}>{i}</a>
        }
        if (i > 1 && i < filterValues.page - 1) {
          if (!showDotsPrev) {
            template = <span key={i} className="pagination__dots">...</span>
            showDotsPrev = true;
          }
        }
        if (i > 1 && (i == filterValues.page || i == filterValues.page - 1 || i == filterValues.page + 1 || i == filterValues.page - 2 || i == filterValues.page + 2) && i < max_num_pages) {
          template = <a key={i} href="#" onClick={e => {
            handlePage(e, 'page', i);
          }} className={`pagination__page ${filterValues.page == i ? '_active' : ''}`}>{i}</a>
        }
        if (i < max_num_pages && i > filterValues.page + 1) {
          if (!showDotsNext) {
            template = <span key={i} className="pagination__dots">...</span>
            showDotsNext = true;
          }
        }
        if (i == max_num_pages) {
          template = <a key={i} href="#" onClick={e => {
            handlePage(e, 'page', i);
          }} className={`pagination__page ${filterValues.page == i ? '_active' : ''}`}>{i}</a>
        }
        return template;
      })}

      {filterValues.page != max_num_pages && (
        <a href="#" className='pagination__next' onClick={e => {
          handlePage(e, 'next');
        }}></a>
      )}

    </div>
  )
}

export default Pagination;